function resetTabIndex() {
    $('a, input, select, button, textarea').each(function () {
        var attr = $(this).attr('tabindex');
        if (typeof attr !== typeof undefined && attr !== false && attr > 0) {
            $(this).attr("tabindex", 0);
        }
    });
};